import type { UiLang } from "site/services/i18n";

export const COMPANY_DETAILS_RU =
  'ООО "900 К" · ИНН 1659145320 · КПП 166001001 · ОКПО 50649378 · ОГРН 1141690032857';

const CYRILLIC_TO_LATIN: Record<string, string> = {
  А: "A",
  Б: "B",
  В: "V",
  Г: "G",
  Д: "D",
  Е: "E",
  Ё: "Yo",
  Ж: "Zh",
  З: "Z",
  И: "I",
  Й: "Y",
  К: "K",
  Л: "L",
  М: "M",
  Н: "N",
  О: "O",
  П: "P",
  Р: "R",
  С: "S",
  Т: "T",
  У: "U",
  Ф: "F",
  Х: "Kh",
  Ц: "Ts",
  Ч: "Ch",
  Ш: "Sh",
  Щ: "Shch",
  Ъ: "",
  Ы: "Y",
  Ь: "",
  Э: "E",
  Ю: "Yu",
  Я: "Ya",
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "yo",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "kh",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "shch",
  ъ: "",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
};

export function transliterateCyrillic(text: string): string {
  let out = "";
  for (const ch of text) {
    out += CYRILLIC_TO_LATIN[ch] ?? ch;
  }
  return out;
}

export function formatCompanyDetails(lang: UiLang): string {
  if (lang === "ru") {
    return COMPANY_DETAILS_RU;
  }
  return transliterateCyrillic(COMPANY_DETAILS_RU);
}
